

let youtube_videoId = '';
let youtube_hasInitialized = false;

/**
 * Initialize YouTube iframe API
 */
export const initYouTube = (videoId) => {
    youtube_videoId = videoId;

    // Let's not run more than once
    if (youtube_hasInitialized) {
        return;
    }

    // Sanity check. 
    if (!youtube_videoId || youtube_videoId === '') {
        // hide player cover
        document.querySelector('.youtube').style.display = 'none';
        return;
    }

    // Custom play button as a cover
    var cover = document.querySelector('.player-cover');

    // 2. This code loads the IFrame Player API code asynchronously.
    var tag = document.createElement('script');

    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // 3. This function creates an <iframe> (and YouTube player)
    //    after the API code downloads.
    var player;
    function onYouTubeIframeAPIReady() {
        player = new YT.Player('player', {
            height: '390',
            width: '640',
            videoId: youtube_videoId,
            playerVars: {
                rel: 0,
                showinfo: 0,
                modestbranding: 1
            },
            events: {
                'onReady': onPlayerReady,
                'onStateChange': onPlayerStateChange
            }
        });
    }

    window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

    // 4. The API will call this function when the video player is ready.
    function onPlayerReady(event) {
        // event.target.playVideo();
        if (cover) {
            cover.player = event.target;
            cover.addEventListener('click', onYouTubeCoverClick);
        }
    }

    // 5. The API calls this function when the player's state changes.
    //    The function indicates that when playing a video (state=1),
    //    the player should play for six seconds and then stop.
    var done = false;
    function onPlayerStateChange(event) {
        // if (event.data == YT.PlayerState.PLAYING && !done) {
        //     setTimeout(stopVideo, 6000);
        //     done = true;
        // }


        // check for global ga object
        var ga = window.ga;
        // Reporting label for GA
        var analyticsReportState;
        if (ga) {
            switch (event.data) {
                case YT.PlayerState.ENDED: analyticsReportState = 'ENDED'; break;
                case YT.PlayerState.PLAYING: analyticsReportState = 'PLAYING'; break;
                case YT.PlayerState.PAUSED: analyticsReportState = 'PAUSED'; break;
                case YT.PlayerState.BUFFERING: analyticsReportState = 'BUFFERING'; break;
                case YT.PlayerState.CUED: analyticsReportState = 'CUED'; break;
            }
        }
        // Submit event
        gtag('event', 'statuschange', {
            'event_category': 'Video',
            'event_label': analyticsReportState,
            'value': player.videoId
        });
    }

    function stopVideo() {
        player.stopVideo();
    }
}




/**
 * YouTube custom poster image click event.
 * @param {MouseEvent} e 
 */
const onYouTubeCoverClick = e => {
    // Plays video. of course
    e.currentTarget.player.playVideo();
    // Hide the poster, of couse :)
    e.currentTarget.style.display = 'none';
}







/**
 * Render overview/synopsis text under YouTube clip
 * @param {String} text plain text of overview. make sure there's no issue on quotations
 */
export const renderOverviewText = text => {
    // drop target
    const p = document.querySelector('.overview');
    p.innerHTML = text;
}







/**
 * Render casts and crews
 * @param {Array} credits array of role(string) and names(strings)
 */
export const renderCredits = credits => {
    // Drop target
    const wrapper = document.querySelector('.credits');

    // Roles such as Director and Cast. Rendered in bold font 
    let roleDom;
    //  Names. Simple string of text
    let namesDom;

    // Spacer between roles
    let spacerDom = document.createElement('span');

    // Spacer between credits
    spacerDom.classList.add('col', 's12', 'hide-on-med-and-up');
    spacerDom.appendChild(document.createElement('br'));

    // Loop in
    credits.forEach(credit => {
        roleDom = document.createElement('span');
        roleDom.classList.add('col', 's12', 'm3', 'l2', 'role', 'bold');
        roleDom.innerHTML = credit.role;
        wrapper.appendChild(roleDom);

        namesDom = document.createElement('span');
        namesDom.classList.add('col', 's12', 'm9', 'l10', 'names');
        namesDom.innerHTML = credit.names;
        wrapper.appendChild(namesDom);

        wrapper.appendChild(spacerDom.cloneNode(true));
    })
}


/**
 * Write MPAA rating 
 * @param {String} rating 
 */
export const renderRatings = rating => {
    const doms = document.querySelectorAll('.rating');
    doms.forEach( dom => {
        dom.innerHTML = rating;
    });
}

/**
 * Write Movie Runtime 
 * @param {String} runtime 
 */
export const renderRuntime = runtime => {
    const doms = document.querySelectorAll('.runtime');
    doms.forEach( dom => {
        dom.innerHTML = runtime;
    });
}


/**
 * Write Movie Released Year 
 * @param {String} year 
 */
export const renderYear = year => {
    const doms = document.querySelectorAll('.year');
    doms.forEach( dom => {
        dom.innerHTML = year;
    });
}


export const setRottenTomatoes = isVisible =>{
    const doms = document.querySelectorAll('.badge-rotten-tomatoes');
    doms.forEach (dom => {
        dom.style.display = isVisible ? 'block' : 'none';
    })
}